













































































































































































































































































































































































































































































import Spinner from './components/Spinner'
import { VMoney } from 'v-money'
UsaStates = require('usa-states').UsaStates
usStates = new UsaStates()
axios = require('axios')
dmas = require('./utils.js').dmas
retailers = require('./utils.js').retailers

apiHost = 'http://localhost:8000'
apiHost = 'https://dev-php-app.herokuapp.com' if window.location.host is 'dev-marketplace-api.herokuapp.com'
apiHost = 'https://live-php.herokuapp.com' if window.location.host is 'www.recess.is'

export default 
  name: 'home'
  components: { Spinner }
  directives: { money: VMoney }
  data: ->
    calculatedPrices: null
    attendance: null
    city: null
    ctaEmail: null
    isCalculating: false
    isGenerating: false
    duration: null
    email: null
    website: null
    step: 1
    state: null
    userType: null
    pricing:
      '10x10': null
  computed:
    states: -> usStates.states
    marketType: -> 
      type = 'supplier' if @userType is 'organizer'
      type = 'buyer' if @userType is 'sponsor'
      type || 'buyer'
  methods: 
    calculate: ->      
      return window.alert 'Please provide a city and state.' unless (@city? and @state?)
      return window.alert 'Please provide a valid event duration.' unless @duration?
      return window.alert 'Please provide a valid event attendance.' unless @attendance?
      return window.alert 'Please select whether you are an organizer or sponsor.' unless @userType?
      return window.alert 'Please enter a valid email address.' unless @email?
      if !@isCalculating
        @isCalculating = true
        setTimeout => 
          @isCalculating = false
          @step = 2
        , 1900
    generate: -> 
      return window.alert 'Please provide a 10x10 booth price.' unless !(Object.values(@pricing).every (x) -> x is null)
      if !@isGenerating
        @isGenerating = true
        try
          response = await axios.post(apiHost + '/api/events/generate', {
            city: @city,
            duration: @duration,
            email: @email,
            pricing: @pricing,
            reach: @attendance,
            state: @state,
            website: @website,
            market_type: @marketType
          })
          @calculatedPrices = response.data
          @step = 3
        catch err 
          console.log err
        finally 
          @isGenerating = false
    finalCta: ->
      window.location.href = 'https://app.recess.is/register?market_type=' + @marketType + '&email=' + @email + '&utm_campaign=Pricing%20Calculator&utm_source=website'
    footerCta: ->
      window.location.href = 'https://app.recess.is/register?market_type=' + @marketType + '&email=' + @ctaEmail + '&utm_campaign=Pricing%20Calculator&utm_source=website'
    imageForSpace: (type) -> "https://s3-us-west-1.amazonaws.com/marketplace-live-assets/spaces/booth_#{type}.png"
    percentageForKey: (key) -> parseInt((Math.abs(@pricing[key] - @calculatedPrices[key]) / @calculatedPrices[key]) * 100)
  watch: 
    step: -> window.scrollTo 0, 0
